import $ from 'jquery';

export default class Header {
    constructor() {
        $('.header__ham svg').on('click', function() {
            $(this).toggleClass('active');
            $('.header__menu').toggleClass('active');
        });
    }
}